(function () {
  'use strict';

  var root;
  var dialog;
  var itemsContainer;
  var totalsContainer;
  var bodyField;
  var tokenField;
  var lastTrigger;
  var cartState;
  var lastServerCart;
  var cartMutationInFlight = false;
  var cartMutationTimer = 0;
  var pendingCartChanges = Object.create(null);
  var inventoryByKey = Object.create(null);
  var pricingByKey = Object.create(null);
  var pricingRefreshGuard = window.MerlonsCartPricing && typeof window.MerlonsCartPricing.createRevisionGuard === 'function'
    ? window.MerlonsCartPricing.createRevisionGuard()
    : null;
  var dialogRevision = 0;
  var cartMutationDelay = 45;
  var bundleQuote = null;
  var bundleCheckInFlight = false;
  var bundleSubmitApproved = false;
  var bundleCartRevision = 0;

  function localeCode() {
    var code = (root && root.dataset.locale) || document.documentElement.lang || 'ka';
    if (code.indexOf('ru') === 0) return 'ru-RU';
    if (code.indexOf('en') === 0) return 'en-US';
    return 'ka-GE';
  }

  function money(cents, currency) {
    var amount = Math.trunc((Number(cents) || 0) / 100);
    var code = currency || (root && root.dataset.currency) || 'GEL';
    var grouped = Math.abs(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    var currencyLabel = code === 'GEL' ? '₾' : code;
    if (amount < 0) grouped = '-' + grouped;
    try {
      var currencyPart = new Intl.NumberFormat(localeCode(), {
        style: 'currency',
        currency: code,
        currencyDisplay: 'symbol',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).formatToParts(0).find(function (part) { return part.type === 'currency'; });
      if (currencyPart && code !== 'GEL') currencyLabel = currencyPart.value;
    } catch (error) {
      currencyLabel = code === 'GEL' ? '₾' : code;
    }
    return grouped + ' ' + currencyLabel;
  }

  function textElement(tag, className, value) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    element.textContent = value || '';
    return element;
  }

  function pricingFor(item) {
    if (window.MerlonsCartPricing && typeof window.MerlonsCartPricing.line === 'function') {
      return window.MerlonsCartPricing.line(item, pricingByKey[item.key]);
    }
    var finalLine = Number(item.final_line_price);
    if (!Number.isFinite(finalLine)) finalLine = Number(item.line_price) || 0;
    var retail = Number(item.original_line_price) || 0;
    var savings = Math.max(0, retail - finalLine);
    return { retail: retail, final: finalLine, savings: savings, percent: retail > finalLine ? Math.round((savings * 100) / retail) : 0 };
  }

  function liquidationOptions() {
    return {
      enabled: root && root.dataset.merlonsOrderRequestLiquidationEnabled === 'true',
      threshold: Number(root && root.dataset.merlonsOrderRequestLiquidationThreshold)
    };
  }

  function isLiquidation(item) {
    if (!window.MerlonsCartPricing || typeof window.MerlonsCartPricing.isLiquidation !== 'function') return false;
    var compareAtPrice = Object.prototype.hasOwnProperty.call(pricingByKey, item.key) ? pricingByKey[item.key] : 0;
    var catalogPrice = typeof window.MerlonsCartPricing.catalogPrice === 'function'
      ? window.MerlonsCartPricing.catalogPrice(pricingByKey, item.key, null)
      : null;
    return window.MerlonsCartPricing.isLiquidation({ catalog_price: catalogPrice }, compareAtPrice, liquidationOptions());
  }

  function readableProperties(properties) {
    if (!properties) return [];
    return Object.keys(properties).filter(function (key) {
      return key.charAt(0) !== '_' && properties[key] !== null && properties[key] !== '';
    }).map(function (key) {
      return key + ': ' + String(properties[key]);
    });
  }

  function iconButton(className, action, label, markup) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = className;
    button.dataset.merlonsOrderRequestAction = action;
    button.setAttribute('aria-label', label);
    button.setAttribute('title', label);
    button.innerHTML = markup;
    return button;
  }

  function inventoryLimit(item) {
    if (!item || !Object.prototype.hasOwnProperty.call(inventoryByKey, item.key)) return null;
    var entry = inventoryByKey[item.key];
    var value = entry && entry.maximum;
    return typeof value === 'number' && Number.isFinite(value) ? Math.max(0, value) : null;
  }

  function inventoryQuantity(item) {
    if (!item || !cartState || !Array.isArray(cartState.items)) return Number(item && item.quantity) || 0;
    var entry = inventoryByKey[item.key];
    if (!entry || !entry.variantId) return Number(item.quantity) || 0;
    return cartState.items.reduce(function (total, cartItem) {
      return Number(cartItem.variant_id) === entry.variantId ? total + (Number(cartItem.quantity) || 0) : total;
    }, 0);
  }

  function syncQuantityAvailability(row, item) {
    if (!row || !item) return;
    var increase = row.querySelector('[data-merlons-order-request-action="increase"]');
    if (!increase) return;
    var maximum = inventoryLimit(item);
    var atMaximum = maximum !== null && inventoryQuantity(item) >= maximum;
    increase.disabled = atMaximum;
    increase.setAttribute('aria-disabled', atMaximum ? 'true' : 'false');
    if (maximum !== null) increase.dataset.inventoryMaximum = maximum;
    else delete increase.dataset.inventoryMaximum;
  }

  function quantityControls(item) {
    var controls = document.createElement('div');
    controls.className = 'merlons-order-request__item-controls';

    var quantity = document.createElement('div');
    quantity.className = 'merlons-order-request__quantity-control';
    quantity.setAttribute('role', 'group');
    quantity.setAttribute('aria-label', root.dataset.quantityLabel);
    quantity.appendChild(iconButton(
      'merlons-order-request__quantity-button',
      'decrease',
      root.dataset.decreaseLabel,
      '<span aria-hidden="true">−</span>'
    ));

    var value = document.createElement('output');
    value.className = 'merlons-order-request__quantity-value';
    value.dataset.merlonsOrderRequestQuantity = '';
    value.setAttribute('aria-live', 'polite');
    value.setAttribute('aria-label', root.dataset.quantityLabel);
    value.textContent = item.quantity;
    quantity.appendChild(value);

    quantity.appendChild(iconButton(
      'merlons-order-request__quantity-button',
      'increase',
      root.dataset.increaseLabel,
      '<span aria-hidden="true">+</span>'
    ));
    controls.appendChild(quantity);

    controls.appendChild(iconButton(
      'merlons-order-request__remove',
      'remove',
      root.dataset.removeLabel,
      '<svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18" focusable="false"><path d="M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5M14 11v5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.7"/></svg><span class="merlons-order-request__sr-only">' + root.dataset.removeLabel + '</span>'
    ));
    return controls;
  }

  function renderItem(item) {
    var row = document.createElement('article');
    row.className = 'merlons-order-request__item';
    row.dataset.merlonsOrderRequestItemKey = item.key;

    if (item.image) {
      var image = document.createElement('img');
      image.className = 'merlons-order-request__image';
      image.src = item.image;
      image.alt = item.product_title || item.title || '';
      image.width = 88;
      image.height = 88;
      image.loading = 'lazy';
      row.appendChild(image);
    }

    var details = document.createElement('div');
    details.className = 'merlons-order-request__item-details';
    details.appendChild(textElement('h4', '', item.product_title || item.title));

    if (item.variant_title && item.variant_title !== 'Default Title') {
      details.appendChild(textElement('p', 'merlons-order-request__meta', item.variant_title));
    }
    if (item.sku) {
      details.appendChild(textElement('p', 'merlons-order-request__meta', item.sku));
    }
    readableProperties(item.properties).forEach(function (property) {
      details.appendChild(textElement('p', 'merlons-order-request__meta', property));
    });
    details.appendChild(quantityControls(item));
    row.appendChild(details);
    syncQuantityAvailability(row, item);

    var prices = document.createElement('div');
    prices.className = 'merlons-order-request__item-prices';
    var linePricing = pricingFor(item);
    if (linePricing.savings > 0) {
      var original = textElement('s', 'merlons-order-request__original-price merlons-cart-pricing__retail', money(linePricing.retail, cartState.currency));
      prices.appendChild(original);
    }
    prices.appendChild(textElement('strong', 'merlons-cart-pricing__final', money(linePricing.final, cartState.currency)));
    if (linePricing.savings > 0) {
      var liquidation = isLiquidation(item);
      var label = textElement(
        'span',
        'merlons-cart-pricing__percent',
        liquidation ? root.dataset.merlonsOrderRequestLiquidationLabel : root.dataset.percentOffLabel.replace('__MERLONS_PERCENT__', linePricing.percent)
      );
      label.dataset.merlonsCartPricingIsLiquidation = liquidation ? 'true' : 'false';
      prices.appendChild(label);
    }
    row.appendChild(prices);

    return row;
  }

  function totals(cart) {
    if (window.MerlonsCartPricing && typeof window.MerlonsCartPricing.totals === 'function') {
      return window.MerlonsCartPricing.totals(cart, pricingByKey);
    }
    var finalTotal = Number(cart.total_price);
    if (!Number.isFinite(finalTotal)) finalTotal = 0;
    return { retail: finalTotal, final: finalTotal, savings: 0, percent: 0 };
  }

  function addTotal(label, value, className) {
    var row = document.createElement('div');
    row.className = 'merlons-order-request__total-row' + (className ? ' ' + className : '');
    row.appendChild(textElement('span', '', label));
    row.appendChild(textElement('strong', '', value));
    totalsContainer.appendChild(row);
  }

  function addPercentBadge(percent) {
    totalsContainer.appendChild(textElement('span', 'merlons-order-request__total-percent merlons-cart-pricing-summary__percent', root.dataset.percentOffLabel.replace('__MERLONS_PERCENT__', percent)));
  }

  function renderCart(cart) {
    bundleQuote = null;
    bundleCartRevision += 1;
    cartState = cart;
    lastServerCart = cart;
    itemsContainer.textContent = '';
    totalsContainer.textContent = '';
    var items = cart.items || [];
    items.forEach(function (item) {
      itemsContainer.appendChild(renderItem(item));
    });

    if (!items.length) itemsContainer.textContent = root.dataset.emptyMessage;
    root.classList.toggle('is-empty', !items.length);

    var summary = totals(cart);
    if (summary.savings > 0) {
      addTotal(root.dataset.retailTotalLabel, money(summary.retail, cart.currency), 'merlons-order-request__total-row--original merlons-cart-pricing-summary__retail');
      addPercentBadge(summary.percent);
    }
    addTotal(root.dataset.finalTotalLabel, money(summary.final, cart.currency), 'merlons-order-request__total-row--final merlons-cart-pricing-summary__final');
    if (tokenField) tokenField.value = cart.token || '';
    var submit = root.querySelector('.merlons-order-request__submit');
    if (submit) submit.disabled = bundleCheckInFlight || !items.length || cartMutationInFlight || Object.keys(pendingCartChanges).length > 0;
  }

  function cartItemByKey(key) {
    var items = cartState && cartState.items ? cartState.items : [];
    for (var index = 0; index < items.length; index += 1) {
      if (items[index].key === key) return items[index];
    }
    return null;
  }

  function rowByKey(key) {
    var rows = itemsContainer.querySelectorAll('[data-merlons-order-request-item-key]');
    for (var index = 0; index < rows.length; index += 1) {
      if (rows[index].dataset.merlonsOrderRequestItemKey === key) return rows[index];
    }
    return null;
  }

  function setMutationBusy(isBusy) {
    root.classList.toggle('is-updating', isBusy);
    var submit = root.querySelector('.merlons-order-request__submit');
    if (submit) submit.disabled = isBusy || root.classList.contains('is-empty');
  }

  function updateOptimisticQuantity(key, quantity) {
    var item = cartItemByKey(key);
    var row = rowByKey(key);
    if (item) item.quantity = quantity;
    if (!row) return;
    row.classList.add('is-updating');
    row.classList.toggle('is-removing', quantity === 0);
    row.setAttribute('aria-busy', 'true');
    var value = row.querySelector('[data-merlons-order-request-quantity]');
    if (value && quantity > 0) value.textContent = quantity;
    syncQuantityAvailability(row, item);
  }

  function syncCartSurfaces(cart) {
    Array.prototype.forEach.call(document.querySelectorAll('.CartCount, #CartCountCavas'), function (count) {
      count.textContent = cart.item_count;
    });
    var desktopCart = document.querySelector('#desktop_cart');
    if (desktopCart) desktopCart.classList.toggle('item_count', cart.item_count > 0);

    if (window.MerlonsCartUI && typeof window.MerlonsCartUI.applyCartState === 'function') {
      window.MerlonsCartUI.applyCartState(cart);
    } else {
      document.dispatchEvent(new CustomEvent('merlons:order-request:cart-updated', { detail: { cart: cart } }));
    }
  }

  function showMutationError() {
    var errorNotice = root.querySelector('[data-merlons-order-request-error]');
    if (!errorNotice) return;
    errorNotice.textContent = root.dataset.errorMessage;
    errorNotice.dataset.merlonsCartMutationError = '';
    errorNotice.hidden = false;
  }

  function clearMutationError() {
    var errorNotice = root.querySelector('[data-merlons-order-request-error]');
    if (!errorNotice || !errorNotice.hasAttribute('data-merlons-cart-mutation-error')) return;
    errorNotice.hidden = true;
    errorNotice.removeAttribute('data-merlons-cart-mutation-error');
  }

  async function processNextCartChange() {
    window.clearTimeout(cartMutationTimer);
    if (cartMutationInFlight) return;
    var keys = Object.keys(pendingCartChanges);
    if (!keys.length) {
      setMutationBusy(false);
      return;
    }

    var key = keys[0];
    var quantity = pendingCartChanges[key];
    delete pendingCartChanges[key];
    cartMutationInFlight = true;
    setMutationBusy(true);

    try {
      var response = await fetch(root.dataset.cartChangeUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: 'id=' + encodeURIComponent(key) + '&quantity=' + encodeURIComponent(quantity)
      });
      if (!response.ok) throw new Error('Cart update failed');
      lastServerCart = await response.json();
      clearMutationError();
    } catch (error) {
      pendingCartChanges = Object.create(null);
      showMutationError();
      await loadCart();
    } finally {
      cartMutationInFlight = false;
    }

    if (Object.keys(pendingCartChanges).length) {
      processNextCartChange();
      return;
    }

    if (lastServerCart) {
      var mutationRevision = pricingRefreshGuard ? pricingRefreshGuard.next() : 0;
      var mutationPricing = await loadPricingSnapshot(lastServerCart);
      if (pricingRefreshGuard && !pricingRefreshGuard.isCurrent(mutationRevision)) {
        if (!cartMutationInFlight && !Object.keys(pendingCartChanges).length) setMutationBusy(false);
        return;
      }
      pricingByKey = mutationPricing;
      renderCart(lastServerCart);
      syncCartSurfaces(lastServerCart);
    }
    setMutationBusy(false);
  }

  function enqueueCartChange(key, quantity) {
    bundleQuote = null;
    bundleCartRevision += 1;
    if (pricingRefreshGuard) pricingRefreshGuard.next();
    pendingCartChanges[key] = Math.max(0, Math.round(quantity));
    updateOptimisticQuantity(key, pendingCartChanges[key]);
    setMutationBusy(true);
    if (!cartMutationInFlight) {
      window.clearTimeout(cartMutationTimer);
      cartMutationTimer = window.setTimeout(processNextCartChange, cartMutationDelay);
    }
  }

  function cartBody() {
    var name = document.getElementById('MerlonsOrderRequestName');
    var phone = document.getElementById('MerlonsOrderRequestPhone');
    var lines = [];
    var summary = totals(cartState || { items: [], total_price: 0 });

    lines.push('Name: ' + (name ? name.value.trim() : ''));
    lines.push('Phone: ' + (phone ? phone.value.trim() : ''));
    lines.push('');
    lines.push('Products:');
    (cartState.items || []).forEach(function (item, index) {
      lines.push((index + 1) + '. ' + (item.product_title || item.title));
      if (item.variant_title && item.variant_title !== 'Default Title') lines.push('   Variant: ' + item.variant_title);
      if (item.sku) lines.push('   SKU: ' + item.sku);
      lines.push('   Quantity: ' + item.quantity);
      Object.keys(item.properties || {}).forEach(function (key) {
        var value = item.properties[key];
        if (value !== null && value !== '') lines.push('   ' + key + ': ' + String(value));
      });
      var itemPricing = pricingFor(item);
      if (itemPricing.savings > 0) {
        lines.push('   ' + root.dataset.retailLabel + ': ' + money(itemPricing.retail, cartState.currency));
      }
      lines.push('   Line total: ' + money(itemPricing.final, cartState.currency));
      var bundleLine = bundleQuote && bundleQuote.lines.find(function (line) { return line.key === item.key && line.bundle; });
      if (bundleLine) {
        lines.push('   Bundle components (total quantity for this line):');
        bundleLine.components.forEach(function (component) { lines.push('      ' + window.MerlonsBundleRequest.componentText(component)); });
      }
    });
    lines.push('');
    if (summary.savings > 0) {
      lines.push(root.dataset.retailTotalLabel + ': ' + money(summary.retail, cartState.currency));
    }
    lines.push(root.dataset.finalTotalLabel + ': ' + money(summary.final, cartState.currency));
    lines.push('Cart token: ' + (cartState.token || ''));
    if (bundleQuote) lines.push('Bundle availability checked: ' + bundleQuote.checkedAt + '. Request only; stock is not reserved.');
    return lines.join('\n');
  }

  function setBusy(isBusy) {
    root.classList.toggle('is-loading', isBusy);
    dialog.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    var submit = root.querySelector('.merlons-order-request__submit');
    if (submit) submit.disabled = bundleCheckInFlight || isBusy || !cartState || !cartState.items || !cartState.items.length || cartMutationInFlight || Object.keys(pendingCartChanges).length > 0;
  }

  function hasPausedBonus(cart) {
    if (!window.theme || window.theme.show_cart_discount_progress !== false) return false;
    function isBonus(application) {
      if (!application || application.type !== 'automatic' || application.value_type !== 'percentage') return false;
      var title = String(application.title || '').trim().toLowerCase();
      return (title === 'merlons 15%' && Number(application.value) === 15)
        || (title === 'merlons 20%' && Number(application.value) === 20);
    }
    return (cart.cart_level_discount_applications || []).some(isBonus)
      || (cart.items || []).some(function (item) {
        return (item.line_level_discount_allocations || []).some(function (allocation) { return isBonus(allocation.discount_application); });
      });
  }

  function cartContents(cart) {
    return JSON.stringify([cart.token, cart.currency, (cart.items || []).map(function (item) {
      var properties = item.properties || {};
      return [item.variant_id, item.quantity, Object.keys(properties).sort().map(function (key) { return [key, properties[key]]; }),
        item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id];
    }).sort(function (a, b) { return JSON.stringify(a).localeCompare(JSON.stringify(b)); })]);
  }

  async function refreshPausedBonus(cart, isCurrent) {
    if (!hasPausedBonus(cart)) return cart;
    function failed() { return new Error(root.dataset.errorMessage); }
    try {
      // Old Shopify carts can retain an expired automatic discount. Read again
      // before one same-quantity update; Shopify recalculates the real prices.
      var latestResponse = await fetch(root.dataset.cartJsonUrl, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!latestResponse.ok) throw failed();
      var latest = await latestResponse.json();
      if (!isCurrent()) throw failed();
      if (!hasPausedBonus(latest)) return latest;
      if (cartContents(latest) !== cartContents(cart)) throw failed();
      var line = latest.items && latest.items[0];
      if (!line || typeof line.key !== 'string' || !line.key || !Number.isSafeInteger(line.quantity) || line.quantity < 1) throw failed();
      var response = await fetch(root.dataset.cartChangeUrl, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: line.quantity })
      });
      if (!response.ok) throw failed();
      var refreshed = await response.json();
      if (hasPausedBonus(refreshed) || cartContents(refreshed) !== cartContents(latest)) throw failed();
      return refreshed;
    } catch (error) {
      // An uncertain response must never become a request with the old bonus.
      throw failed();
    }
  }

  async function loadCart() {
    var loadRevision = pricingRefreshGuard ? pricingRefreshGuard.next() : 0;
    var openingRevision = dialogRevision;
    function isCurrent() { return openingRevision === dialogRevision && (!pricingRefreshGuard || pricingRefreshGuard.isCurrent(loadRevision)); }
    cartState = null;
    setBusy(true);
    try {
      var inventoryRequest = loadInventory();
      var response = await fetch(root.dataset.cartJsonUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart request failed');
      var cart = await response.json();
      await inventoryRequest;
      var refreshed = await refreshPausedBonus(cart, isCurrent);
      if (!isCurrent()) return false;
      var bonusRefreshed = refreshed !== cart;
      if (bonusRefreshed) {
        cart = refreshed;
        await loadInventory();
      }
      var loadedPricing = await loadPricingSnapshot(cart);
      if (!isCurrent()) return false;
      pricingByKey = loadedPricing;
      if (!cart.items || !cart.items.length) throw new Error(root.dataset.emptyMessage);
      renderCart(cart);
      if (bonusRefreshed) syncCartSurfaces(cart);
      clearMutationError();
      return true;
    } catch (error) {
      if (!isCurrent()) return false;
      itemsContainer.textContent = error.message || root.dataset.emptyMessage;
      totalsContainer.textContent = '';
      return false;
    } finally {
      if (isCurrent()) setBusy(false);
    }
  }

  async function loadPricingSnapshot(cart) {
    if (!window.MerlonsCartPricing || typeof window.MerlonsCartPricing.fetchSnapshot !== 'function') return Object.create(null);
    if (typeof window.MerlonsCartPricing.seedFromDom === 'function') {
      window.MerlonsCartPricing.seedFromDom(cart, document);
    }
    return window.MerlonsCartPricing.fetchSnapshot(cart, root.dataset.cartPricingUrl);
  }

  async function checkBundles() {
    if (root.dataset.bundlesEnabled !== 'true') return;
    var helper = window.MerlonsBundleRequest;
    if (!helper) throw new Error('bundle-unverified');
    var revision = bundleCartRevision;
    var result = await helper.validate(cartState, root.dataset.bundlesCartUrl, root.dataset.bundlesProxyUrl);
    if (revision !== bundleCartRevision || result.fingerprint !== helper.fingerprint(cartState)) {
      console.warn('[Merlons Bundles] cart-revision'); throw new Error('cart-changed');
    }
    bundleQuote = result.quote;
    if (!bundleQuote) return;
    bundleQuote.lines.filter(function (line) { return line.bundle; }).forEach(function (line) {
      var row = rowByKey(line.key);
      if (!row) return;
      if (Number.isSafeInteger(line.available) && line.available >= 0) {
        inventoryByKey[line.key] = { variantId: Number(line.variantId.split('/').pop()), maximum: line.available };
        syncQuantityAvailability(row, cartItemByKey(line.key));
      }
    });
  }

  function bundleError(error) {
    var helper = window.MerlonsBundleRequest, labels = helper && helper.labels(root.dataset.locale);
    var diagnosticCodes = {
      'cart-changed': true, 'cart-price-stale': true, 'bundle-unavailable': true,
      'bundle-unverified': true, 'invalid-cart': true, 'response-too-large': true,
      'unsupported-cart-grouping': true, 'validation-url-invalid': true
    };
    var diagnosticNames = {
      Error: true, TypeError: true, SyntaxError: true, AbortError: true,
      TimeoutError: true, DOMException: true
    };
    var code = error && diagnosticCodes[error.message] ? error.message : 'unexpected';
    var name = error && diagnosticNames[error.name] ? error.name : 'UnknownError';
    console.warn('[Merlons Bundles] request-error', code, name);
    var notice = root.querySelector('[data-merlons-order-request-error]');
    notice.textContent = labels ? error.message === 'cart-changed' ? labels.changed : labels.error : root.dataset.errorMessage;
    notice.hidden = false;
  }

  async function submitWithBundles(form, submitter) {
    bundleCheckInFlight = true;
    var dialogAtStart = dialogRevision;
    try {
      var helper = window.MerlonsBundleRequest;
      if (!helper) throw new Error('bundle-unverified');
      var before = helper.fingerprint(cartState);
      if (!await loadCart()) throw new Error('bundle-unverified');
      if (helper.fingerprint(cartState) !== before) throw new Error('cart-changed');
      await checkBundles();
      var revision = bundleCartRevision;
      var response = await fetch(root.dataset.cartJsonUrl, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(15000) });
      if (!response.ok) throw new Error('bundle-unverified');
      var confirmedCart = await response.json();
      if (revision !== bundleCartRevision || helper.fingerprint(confirmedCart) !== helper.fingerprint(cartState)) throw new Error('cart-changed');
      if (root.hidden || dialogRevision !== dialogAtStart) return;
      bundleCheckInFlight = false; setBusy(false); bundleSubmitApproved = true;
      try { if (submitter) form.requestSubmit(submitter); else form.requestSubmit(); }
      finally { bundleSubmitApproved = false; }
    } catch (error) {
      bundleQuote = null;
      if (error.message === 'cart-price-stale' && !root.hidden && dialogRevision === dialogAtStart) {
        try {
          await helper.refreshPrice(cartState, error.lineKey, root.dataset.cartJsonUrl, root.dataset.cartChangeUrl);
          if (!await loadCart()) throw new Error('bundle-unverified');
          syncCartSurfaces(cartState);
          // Never submit in the same click as a price refresh. The next click
          // revalidates everything after the customer has reviewed the total.
          error = new Error('cart-changed');
        } catch (refreshError) { error = refreshError; }
      }
      bundleError(error);
    }
    finally { bundleCheckInFlight = false; setBusy(false); }
  }

  async function loadInventory() {
    var nextInventory = Object.create(null);
    if (!root.dataset.cartInventoryUrl) {
      inventoryByKey = nextInventory;
      return;
    }
    try {
      var response = await fetch(root.dataset.cartInventoryUrl, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Cart inventory request failed');
      var payload = await response.json();
      (payload.items || []).forEach(function (entry) {
        nextInventory[entry.key] = {
          variantId: Number(entry.variant_id) || 0,
          maximum: entry.max === null ? null : Number(entry.max)
        };
      });
      inventoryByKey = nextInventory;
    } catch (error) {
      inventoryByKey = nextInventory;
    }
  }

  async function open(trigger) {
    if (!root) return;
    lastTrigger = trigger || document.activeElement;
    var openRevision = ++dialogRevision;
    root.hidden = false;
    document.documentElement.classList.add('merlons-order-request-open');
    await loadCart();
    if (cartState && root.dataset.bundlesEnabled === 'true') {
      try { await checkBundles(); } catch (error) { bundleError(error); }
    }
    window.requestAnimationFrame(function () {
      if (root.hidden || openRevision !== dialogRevision) return;
      dialog.focus();
      var name = document.getElementById('MerlonsOrderRequestName');
      if (name) name.focus();
    });
  }

  function close() {
    if (!root) return;
    root.hidden = true;
    dialogRevision += 1;
    if (pricingRefreshGuard) pricingRefreshGuard.next();
    document.documentElement.classList.remove('merlons-order-request-open');
    var focusTarget = lastTrigger && document.documentElement.contains(lastTrigger) && !lastTrigger.disabled
      ? lastTrigger
      : document.querySelector('.merlons-order-request-trigger, [data-merlons-order-request-open], .header-cart[role="button"], .header-cart');
    if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus();
    lastTrigger = null;
  }

  function isCheckoutLink(element) {
    if (!element || !element.matches) return false;
    if (element.matches('.merlons-order-request-trigger, [data-merlons-order-request-open]')) return true;
    if (element.matches('a[href*="/checkout"]')) return true;
    return element.matches('button[name="checkout"], input[name="checkout"]');
  }

  function onClick(event) {
    var cartAction = event.target.closest('[data-merlons-order-request-action]');
    if (cartAction && !root.hidden) {
      event.preventDefault();
      event.stopPropagation();
      if (bundleCheckInFlight) return;
      var row = cartAction.closest('[data-merlons-order-request-item-key]');
      var item = row && cartItemByKey(row.dataset.merlonsOrderRequestItemKey);
      if (!item || row.classList.contains('is-removing')) return;
      var action = cartAction.dataset.merlonsOrderRequestAction;
      var quantity = Number(item.quantity) || 1;
      if (action === 'increase') {
        var maximum = inventoryLimit(item);
        if (cartAction.disabled || (maximum !== null && inventoryQuantity(item) >= maximum)) return;
        enqueueCartChange(item.key, quantity + 1);
      }
      else if (action === 'decrease') enqueueCartChange(item.key, quantity > 1 ? quantity - 1 : 0);
      else if (action === 'remove') enqueueCartChange(item.key, 0);
      return;
    }
    var closeButton = event.target.closest('[data-merlons-order-request-close]');
    if (closeButton) {
      event.preventDefault();
      close();
      return;
    }
    var trigger = event.target.closest('.merlons-order-request-trigger, [data-merlons-order-request-open], a[href*="/checkout"], button[name="checkout"], input[name="checkout"]');
    if (isCheckoutLink(trigger)) {
      event.preventDefault();
      event.stopPropagation();
      open(trigger);
    }
  }

  function onKeydown(event) {
    if (root.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    var focusable = Array.prototype.slice.call(dialog.querySelectorAll('button:not([disabled]), input:not([type="hidden"]):not([disabled]), [href], [tabindex]:not([tabindex="-1"])'));
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function onSubmit(event) {
    if (!event.target.matches('#MerlonsOrderRequestForm')) return;
    // Shopify's contact/captcha bootstrap can call form.submit() even when
    // defaultPrevented is true. Do not let a deferred/invalid attempt reach it.
    // The approved requestSubmit below still follows normal captcha handling.
    function deferSubmission() {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    if (bundleCheckInFlight) { deferSubmission(); return; }
    if (root.classList.contains('is-loading') || root.classList.contains('is-updating') || cartMutationInFlight || Object.keys(pendingCartChanges).length) {
      deferSubmission();
      return;
    }
    if (cartState && hasPausedBonus(cartState)) {
      deferSubmission();
      loadCart();
      return;
    }
    var name = document.getElementById('MerlonsOrderRequestName');
    var phone = document.getElementById('MerlonsOrderRequestPhone');
    var errorNotice = root.querySelector('[data-merlons-order-request-error]');
    if (!cartState || !cartState.items || !cartState.items.length || !name.value.trim() || !phone.value.trim()) {
      deferSubmission();
      errorNotice.textContent = root.dataset.validationMessage;
      errorNotice.hidden = false;
      (!name.value.trim() ? name : phone).focus();
      return;
    }
    errorNotice.hidden = true;
    if (root.dataset.bundlesEnabled === 'true' && !bundleSubmitApproved) {
      deferSubmission();
      submitWithBundles(event.target, event.submitter);
      return;
    }
    try {
      bodyField.value = cartBody();
      if (!bodyField.value.trim()) throw new Error('empty-order-summary');
    } catch (error) {
      deferSubmission();
      errorNotice.textContent = root.dataset.errorMessage;
      errorNotice.hidden = false;
      return;
    }
    // Analytics failure must never block or alter Shopify's normal contact submission.
    try {
      var requestId = window.MerlonsAnalytics && window.MerlonsAnalytics.prepareOrderRequest(cartState);
      var referenceField = root.querySelector('[data-merlons-order-request-reference]');
      if (referenceField) referenceField.value = requestId || '';
      if (requestId) bodyField.value += '\nRequest ID: ' + requestId;
    } catch (error) {}
  }

  function init() {
    root = document.querySelector('[data-merlons-order-request]');
    if (!root) return;
    dialog = root.querySelector('.merlons-order-request__dialog');
    itemsContainer = root.querySelector('[data-merlons-order-request-items]');
    totalsContainer = root.querySelector('[data-merlons-order-request-totals]');
    bodyField = root.querySelector('[data-merlons-order-request-body]');
    tokenField = root.querySelector('[data-merlons-order-request-token]');
    document.addEventListener('click', onClick, true);
    document.addEventListener('keydown', onKeydown);
    document.addEventListener('submit', onSubmit, true);
    document.addEventListener('merlons:cart:state', function (event) {
      if (root.hidden || cartMutationInFlight || Object.keys(pendingCartChanges).length) return;
      if (event.detail && event.detail.cart) {
        if (event.detail.cart === cartState) return;
        if (hasPausedBonus(event.detail.cart)) { loadCart(); return; }
        var eventRevision = pricingRefreshGuard ? pricingRefreshGuard.next() : 0;
        Promise.all([loadInventory(), loadPricingSnapshot(event.detail.cart)]).then(function (results) {
          if (pricingRefreshGuard && !pricingRefreshGuard.isCurrent(eventRevision)) return;
          pricingByKey = results[1];
          renderCart(event.detail.cart);
        });
      }
    });
    document.addEventListener('merlons:order-request:open', function () { open(); });
    window.MerlonsOrderRequest = { open: open, close: close };

    if (document.documentElement.hasAttribute('data-merlons-order-request-return')) open();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
